import { Typography, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CAppDialog from '../../../app/components/CAppDialog';
import AppCustomIcon from '../../../app/features/icon/AppIcon';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import InvestorRoutes from '../../investor/InvestorRoutes';
import { useTranslation } from 'react-i18next';
import langUserFirstLogin from '../langs/langUserFirstLogin';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import useUserProfile from '../hooks/useUserProfile';
import useUserUpdateWelcomed from '../hooks/useUserUpdateWelcomed';

const FUserFirstLoginDialog = () => {
	const { mutate: updateWelcomed } = useUserUpdateWelcomed();
	const { investorProfile } = useUserProfile();
	//welcomed
	const [open, setOpen] = useState<boolean | undefined>(undefined);

	useEffect(() => {
		if (investorProfile) {
			if (investorProfile.welcomed === false) {
				setOpen(true);
			} else {
				setOpen(false);
			}
		}
	}, [investorProfile]);

	const { authContext } = useAuthContext();

	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleClose = (reason: string) => {
		if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
			updateWelcomed();
			setOpen(false);
		}
	};

	return (
		<>
			{authContext && authContext === 'investor' && open !== undefined ? (
				<CAppDialog
					open={open}
					maxWidth="sm"
					title={t(langUserFirstLogin.title.tag)}
					actions={
						<>
							<Button
								variant="contained"
								color="secondary"
								endIcon={<AppCustomIcon tag="arrow-right" />}
								onClick={() => {
									handleClose('');
									navigate(HAppRoutes.getPath(InvestorRoutes.profile.tag));
								}}
							>
								{t(langUserFirstLogin.btn_update_my_first_profile.tag)}
							</Button>{' '}
							<Button
								id="dialog-user-first-login-btn-close"
								variant="contained"
								color="inherit"
								onClick={() => handleClose('')}
							>
								{t(langUserFirstLogin.btn_i_will_do_it_later.tag)}
							</Button>
						</>
					}
				>
					<Typography variant="body1" sx={{ marginBottom: '20px' }}>
						{t(langUserFirstLogin.description.tag)}
					</Typography>
					{investorProfile && investorProfile.features?.emailNotificationEnabled ? (
						<Typography variant="body1">{t(langUserFirstLogin.description2.tag)}</Typography>
					) : (
						<></>
					)}
				</CAppDialog>
			) : (
				''
			)}
		</>
	);
};

export default FUserFirstLoginDialog;
